<template>
  <div>
    </div>
</template>

<script>

  export default {
    name: 'SignupMixin',
    computed: {
      selectedProduct: {
        get () {
          return this.$store.state.selectedProduct;
        },
        set (value) {
          this.$store.commit('updateSelectedProduct', value)
        }
      },
      selectedProductNice: function() {
        if (this.selectedProduct == 'wolfhound') {
          return 'Wolfhound ($25 CAD / month)';
        } else if (this.selectedProduct == 'beagle') {
          return 'Beagle ($15 CAD / month)';
        } else if (this.selectedProduct == 'chow') {
          return 'Chow';
        } else {
          return 'None';
        }
      },
      signupEmail: {
        get () {
          return this.$store.state.signupEmail;
        },
        set (value) {
          this.$store.commit('signupEmail', value)
        }
      },
      signupPassword: {
        get () {
          return this.$store.state.signupPassword;
        },
        set (value) {
          this.$store.commit('signupPassword', value)
        }
      },
      signupGivenName: {
        get () {
          return this.$store.state.signupGivenName;
        },
        set (value) {
          this.$store.commit('signupGivenName', value)
        }
      },
      signupLastName: {
        get () {
          return this.$store.state.signupLastName;
        },
        set (value) {
          this.$store.commit('signupLastName', value)
        }
      },
      signupCompanyName: {
        get () {
          return this.$store.state.signupCompanyName;
        },
        set (value) {
          this.$store.commit('signupCompanyName', value)
        }
      },
      signupAddress1: {
        get () {
          return this.$store.state.signupAddress1;
        },
        set (value) {
          this.$store.commit('signupAddress1', value)
        }
      },
      signupAddress2: {
        get () {
          return this.$store.state.signupAddress2;
        },
        set (value) {
          this.$store.commit('signupAddress2', value)
        }
      },
      signupCity: {
        get () {
          return this.$store.state.signupCity;
        },
        set (value) {
          this.$store.commit('signupCity', value)
        }
      },
      signupProvince: {
        get () {
          return this.$store.state.signupProvince;
        },
        set (value) {
          this.$store.commit('signupProvince', value)
        }
      },
      signupPostal: {
        get () {
          return this.$store.state.signupPostal;
        },
        set (value) {
          this.$store.commit('signupPostal', value)
        }
      },
      signupCountry: {
        get () {
          return this.$store.state.signupCountry;
        },
        set (value) {
          this.$store.commit('signupCountry', value)
        }
      },
      signuptab: {
        get () {
          return this.$store.state.signuptab;
        },
        set (value) {
          this.$store.commit('signuptab', value);
        }
      },
      selectedNumber: {
        get () {
          return this.$store.state.selectedNumber;
        },
        set (value) {
          this.$store.commit('updateSelectedNumber', value)
        }
      },
      selectedProductErrorMessage: function() {
        if (this.selectedProduct == 'beagle') {
          return '';
        } else if (this.selectedProduct == 'wolfhound') {
          return '';
        } else if (this.selectedProduct == 'chow') {
          return '';
        }
        return 'No product is selected.';
      },
      selectedFaxErrorMessage: function() {
        if (this.selectedNumber) {
          return '';
        }
        return 'A fax number must be chosen';
      },
      signupGivenNameErrorMessage: function() {
        if (this.signupGivenName) {
          return '';
        }
        return 'Please provide a given name';
      },
      signupLastNameErrorMessage: function() {
        if (this.signupLastName) {
          return '';
        }
        return 'Please provide a last name';
      },
      signupCompanyNameErrorMessage: function() {
        if (this.signupCompanyName) {
          return '';
        }
        return 'Please provide a company name';
      },
      signupAddress1ErrorMessage: function() {
        if (this.signupAddress1) {
          return '';
        }
        return 'Please provide an address';
      },
      signupAddress2ErrorMessage: function() {
        return '';
      },
      signupCityErrorMessage: function() {
        if (this.signupCity) {
          return '';
        }
        return 'Please provide a city';
      },
      signupProvinceErrorMessage: function() {
        if (this.signupProvince) {
          return '';
        }
        return 'Please provide a province';
      },
      signupCountryErrorMessage: function() {
        if (this.signupCountry) {
          return '';
        }
        return 'Please provide a country name';
      },
      signupPostalErrorMessage: function() {
        if (this.signupPostal) {
          return '';
        }
        return 'Please provide a postal or zip code';
      },
      signupUsernameErrorMessage: function() {
        if (this.signupEmail) {
          return '';
        }
        return 'Please provide your email to login with';
      },
      signupPasswordErrorMessage: function() {
        if (!this.signupPassword) {
          return 'Please choose a password';
        }
        if (this.signupPassword.length < 8) {
          return 'Your password must be at least 8 characters';
        }
        return '';
      },
      allErrorMessages: function() {
        return this.signupPasswordErrorMessage + this.signupUsernameErrorMessage + this.signupPostalErrorMessage +
          this.signupCountryErrorMessage + this.signupProvinceErrorMessage + this.signupCityErrorMessage +
          this.signupAddress1ErrorMessage + this.signupCompanyNameErrorMessage + this.signupLastNameErrorMessage +
          this.signupGivenNameErrorMessage + this.selectedFaxErrorMessage + this.selectedProductErrorMessage;
      },
    },
    data: () => ({
     rules: {
       required: value => !!value || 'Required.',
       email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
     },
    }),
    methods: {
      gotoNext() {
        this.$emit('gotoNext');
      },
      formatNumber(A) {
        if (A) {
         var C=A.replace(/[^0-9xX]/g,"");C=C.replace(/[xX]/g,"x");var B="";if(C.indexOf("x")>-1){B=" "+C.substr(C.indexOf("x"));C=C.substr(0,C.indexOf("x"))}switch(C.length){case (10):return C.replace(/(...)(...)(....)/g,"($1) $2-$3")+B;case (11):if(C.substr(0,1)=="1"){return C.substr(1).replace(/(...)(...)(....)/g,"($1) $2-$3")+B}break;default:}return A;
        } else {
          return null;
        }
      }
    },
    beforeMount() {
    },
    watch: {
      
    },
    filters: {

    },
  }
</script>
